module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"xml":"XML"},"et":{"xml":"XML"},"ru":{"xml":"XML"}}')
  delete Component.options._Ctor
}
